'use client';

import * as React from 'react';
import './styles.scss';

export interface IStickyProps {
  children?: React.ReactNode;
}

const Sticky: React.FunctionComponent<IStickyProps> = (props) => {
  return (
    <React.Fragment>
      <div className={'sticky'}>{props.children}</div>
      <div className={'sticky__mock'} />
    </React.Fragment>
  );
};

Sticky.displayName = 'Sticky';

export default Sticky;
